import type { FolderTree as FolderTreeType } from '@/hooks/useFolders'
import { crimsonFolderNameTrail } from './syncMapping'

export function imanageParentPath(path?: string): string | undefined {
  const parentPath = path
    ?.split(' / ')
    .filter(Boolean)
    .slice(0, -1)
    .join(' / ')
  return parentPath || undefined
}

export function crimsonDestinationLabel(
  destinationFolder: FolderTreeType | null | undefined,
  folderTree: FolderTreeType[],
): string {
  if (!destinationFolder) {
    return 'Root'
  }
  const trail = crimsonFolderNameTrail(destinationFolder.folder_id, folderTree)
  return trail?.join(' / ') || destinationFolder.name
}

export function sortFoldersByName<T extends { name: string }>(folders: T[]): T[] {
  return [...folders].sort((left, right) => (
    left.name.localeCompare(right.name, undefined, { numeric: true, sensitivity: 'base' })
  ))
}
